import React from 'react';
import SecurityPart from '../security-part';
import * as styles from './index.module.less';
import NewsLetter from '@/components/newsletter';

const Copywriting = {
  ja: {
    title: '最新機能<wbr/>や<wbr/>キャンペーン・<wbr/>AI関連情報<wbr/>を<wbr/>お届けいたします',
  },
  en: {
    title: 'Subscribe to be in sync with the latest news and trends',
  },
};

export const FooterSecurityInfo = () => {
  return (
    <div className={`${styles.security_new_letter} security_newsletter_footer`}>
      {/* 安全logo */}
      <div className={styles.security_switch_btn_container}>
        <SecurityPart />
        <span className={styles.security_desc}>
          「GDPR」「SSL」「SOC 2」「ISO 27001」「HIPAA」「CCPA」「APPI」の
          <wbr />
          認証
          <wbr />を<wbr />
          取得
          <wbr />
          して
          <wbr />
          います。
        </span>
      </div>
      <NewsLetter
        classNames={styles.new_letter__container}
        locale={'ja'}
        outerClassName="security_newsletter_footer"
        copywriting={{ ...Copywriting['ja'] }}
      />
    </div>
  );
};
